<template>
    <div>
        <div class="tableDiv">
            <raw-data-table-base 
                :status-info="StatusInfo" 
                :table-id="tableId" 
                :api-info="ApiInfo" 
                :trial-id="TrialId" 
                :progeny-id="ProgenyId" 
                :palm-id="PalmId" 
                :selection-row="selectionRow"
                :export-info="exportInfo"
                @updateParam="$_updateTableParam($event)"
                @reloadTable="reloadTable()"
            >
                <template #TableTitle>
                    <h4>Bunch Data</h4>
                </template>
                <template v-if="isShowTable" #RawTable>
                    <!-- <table id="rawBunchInfoTable" class="table" style="width:100%"></table> -->
                    <keep-alive>
                        <agrinome-table
                            :key="tableKey"
                            ref="agrinome-table"
                            :api-mode="true"
                            :columns="columns"
                            :selection-row.sync="selectionRow"
                            :http-options="httpOptions"
                            :api-url="apiUrl"
                            :append-params="appendParams"
                            @handle-sort="handleSort"
                            @handle-search="handleSearch"
                            @handle-edit="handleEdit"
                            @confirm-edit="confirmEdit"
                            @handle-delete="handleDelete"
                        />
                    </keep-alive>
                </template>
            </raw-data-table-base>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import DataFlag from "@/components/DataFlag";
import Router from "vue-router";
import BunchRawVariable from "@/assets/json/bunch-raw-variable.json";
import { statusBtn } from "@/assets/button/statusBtn.js";
Vue.use(Router);

const status = require("@/smallComponents/RecordStatus.vue");

export default {
    props: ["PalmId", "TrialId", "ProgenyId"],
    data() {
        return {
            tableCode: "RAW",
            tableId: "#rawBunchInfoTable",
            StatusInfo: null,
				
            ApiInfo: {
                Table: "BunchData",
                UpdateManyKey: "bunchDataList",
                RepopulateMeanApi: "RepopulateBunchDerivedData"
            },

            exportInfo: {
                exportUrl: "BunchData/ExportRaw",
                sortValue: "",
                searchValue: ""
            },

            appendParams: {
                PalmId: null,
                TrialId: null,
                ProgenyId: null,
                HasFailChecking: null,
                Status: null,
                RecordDateFrom: null,
                RecordDateTo: null,
                PalmNumber: null
            },

            columns: [
                {
                    name: "id",
                    label: "ID",
                    sortable: "custom",
                    width: "70",
                    isDisableEdit: true,
                    link: {
                        pageName: "RawBunchDetail",
                        linkId: "id"
                    }
                },
                {
                    name: "palmTrialPalmNumber",
                    label: "Palm No",
                    sortable: "custom",
                    width: "105",
                    link: {
                        pageName: "PalmDetail",
                        linkId: "palmId"
                    }
                },
                {
                    name: "palmTrialPalmId",
                    label: "Palm ID",
                    sortable: "custom",
                    minWidth: "180",
                },
                ...this.getBunchRawVariableInTable(),
                { 
                    name: "recordDate", 
                    label: "Record Date", 
                    width: "170",
                    formatter: this.$_getCreationTimeFormat(),
                    datetime: true,
                    sortable: "custom"
                },
                { 
                    name: "creatorUser.userName", 
                    label: "Created By", 
                    width: "150",
                    sortable: "custom",
                    editOptsApi: "/api/services/app/User/GetAllForDropdown",
                    editOptId: "creatorUserId",
                },
                {
                    name: "creationTime",
                    label: "Created At",
                    width: "170",
                    sortable: "custom",
                    formatter: this.$_getCreationTimeFormat(),
                    isDisableEdit: true
                },
                {
                    name: "",
                    label: "Condition Flag",
                    sortable: "custom",
                    width: 85,
                    customVueComponent: this.getDataFlaggedComponent(),
                    customVueComponentParams: {
                        "name": "bunchFlaggedDatas",
                    }
                },
                {
                    name: "",
                    label: "Range Flag",
                    sortable: "custom",
                    width: "85",
                    custom: true,
                    callbackFn: this.$_getSamplingsFlaggedCallBack("palm.betweenSamplingsFlaggedPalms")
                },
                {
                    name: "status",
                    label: "Status",
                    sortable: "custom",
                    width: "85",
                    editOpts: [
                        { name: "OK", value: "OK" },
                        { name: "R", value: "R" },
                        { name: "KIV", value: "KIV" },
                        { name: "-", value: null },
                    ],
                    editOptId: "status",
                }
            ],
                
            selectionRow: [],
            apiUrl: "/api/services/app/BunchData/GetAll",
            httpOptions: ApiConfig.getHttpOption(),
                
            tableKey: 1,
            isShowTable: false,
        };
    },
    computed: {
        sharedAgrinomeTableState: {
            get() { return this.$store.state.isUpdateAgrinomeTable; }
        },
    },
    watch: {
        selectionRow() {
            store.commit("storeSelectionRow", this.selectionRow);
        },
        sharedAgrinomeTableState() {
            if (this.$store.state.isUpdateAgrinomeTable) {
                this.$_reloadAgrinomeTable();
                this.$store.commit("updateAgrinomeTableState", false);
            }
        }
    },
    mounted() {
        this.$nextTick(function() {
            this.appendParams.PalmId = this.PalmId;
            this.appendParams.TrialId = this.TrialId;
            this.appendParams.ProgenyId = this.ProgenyId;
            this.appendParams.IsRawData = true;
            this.isShowTable = true;

            if (!this.PalmId && !this.TrialId && !this.ProgenyId) {
                this.pageLength = 25;
            }
        });
    },
    methods: {
        getDataFlaggedComponent() {
            return DataFlag;
        },
        getBunchRawVariableInTable() {
            // Agrinome Table Test
            return BunchRawVariable.map((item, index) => ({
                name: item.data,
                label: `${item.data} (${item.title})`,
                sortable: "custom",
                width: "85"
            }));
        },
        getUsersDropdown() {
            var self = this;
            axios({
                method: "GET",
                url: "User/GetAllForDropdown"
            }).then(function (response) {
                console.log(response.data.result);
            });
        },
        handleSort(sortValue) {
            this.exportInfo.sortValue = sortValue;
        },
        handleSearch(searchValue) {
            this.exportInfo.searchValue = searchValue;
        },
        handleEdit(index, row) {
            // this.getUsersDropdown();
        },
        confirmEdit(index, row) {
            this.$_confirmTableEdit(index, row, this.ApiInfo.Table);
        },
        handleDelete(index, row) {
            var self = this;
            DialogBus.$emit("open", {
                component: DeleteConfirmation,
                title: "Are you sure",
                props: { apiUrl: self.ApiInfo.Table + "/Delete", data: { id: row.id }, refs: "agrinome-table" },
                onSuccess: function onSuccess() {
                    self.tableKey++;
                }
            });
        },
        reloadTable() {
            this.$_reloadAgrinomeTable();
        }
    }
};
</script>
	<style scoped>
	</style>



// WEBPACK FOOTER //
// src/components/Palm/PalmRawData/RawBunchDataTable.vue